import React from "/vendor/react";
import PropTypes from "prop-types";

import ConfirmDelete from "/lib/component/partial/ConfirmDelete";
import ListHeader from "/lib/component/partial/ListHeader";
import ListSortSelector from "/lib/component/partial/ListSortSelector";
import ToolbarMenu from "/lib/component/partial/ToolbarMenu";
import {
  DeleteMenuItem,
  NewMenuItem,
  SelectMenuItem,
} from "/lib/component/partial/ToolbarMenuItems";
import ToolbarSelectOption from "/lib/component/partial/ToolbarSelect/Option";

import { toggleParam } from "/lib/util/filterParams";

const HANDLER_TYPES = [
  { label: "PIPE", value: "pipe" },
  { label: "SET", value: "set" },
  { label: "TCP", value: "tcp" },
  { label: "UDP", value: "udp" },
];

const HandlersListHeader = ({
  editable,
  filters,
  selectedItems,
  rowCount,
  onChangeQuery,
  onChangeFilters,
  onClickNew,
  onClickDelete,
  onClickSelect,
  order,
}) => {
  const onFilterHandlerType = toggleParam("type", onChangeFilters);
  const onSort = onChangeQuery;
  const selectedCount = selectedItems.length;

  return (
    <ListHeader
      sticky
      editable={editable}
      selectedCount={selectedCount}
      rowCount={rowCount}
      onClickSelect={onClickSelect}
      renderActions={() => (
        <ToolbarMenu>
          <ToolbarMenu.Item key="new" visible="always">
            <NewMenuItem
              title="New handler…"
              titleCondensed="New"
              onClick={onClickNew}
            />
          </ToolbarMenu.Item>
          <ToolbarMenu.Item key="type-filter" visible="if-room">
            <SelectMenuItem title="Type" onChange={onFilterHandlerType}>
              {HANDLER_TYPES.map(({ label, value }) => (
                <ToolbarSelectOption
                  key={value}
                  value={value}
                  selected={filters.type === value}
                >
                  {label}
                </ToolbarSelectOption>
              ))}
            </SelectMenuItem>
          </ToolbarMenu.Item>
          <ToolbarMenu.Item key="sort" visible="if-room">
            <ListSortSelector
              options={[{ label: "Name", value: "NAME" }]}
              onChangeQuery={onSort}
              value={order}
            />
          </ToolbarMenu.Item>
        </ToolbarMenu>
      )}
      renderBulkActions={() => (
        <ToolbarMenu>
          <ToolbarMenu.Item key="delete" visible="always">
            {(menu) => (
              <ConfirmDelete
                identifier={`${selectedCount} ${
                  selectedCount === 1 ? "handler" : "handlers"
                }`}
                onSubmit={() => {
                  onClickDelete();
                  menu.close();
                }}
              >
                {(dialog) => (
                  <DeleteMenuItem
                    autoClose={false}
                    description="Delete selected handlers."
                    onClick={dialog.open}
                  />
                )}
              </ConfirmDelete>
            )}
          </ToolbarMenu.Item>
        </ToolbarMenu>
      )}
    />
  );
};

HandlersListHeader.propTypes = {
  editable: PropTypes.bool,
  filters: PropTypes.object.isRequired,
  selectedItems: PropTypes.array.isRequired,
  rowCount: PropTypes.number.isRequired,
  onChangeQuery: PropTypes.func.isRequired,
  onChangeFilters: PropTypes.func.isRequired,
  onClickNew: PropTypes.func,
  onClickDelete: PropTypes.func,
  onClickSelect: PropTypes.func,
  order: PropTypes.string.isRequired,
};

HandlersListHeader.defaultProps = {
  editable: false,
  onClickNew: () => null,
  onClickDelete: () => null,
  onClickSelect: () => null,
};

export default HandlersListHeader;
